module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/90b07372f18d4d67baf702bc8347ffa2.png";